<template>
    <div class="image-viewer">
        <img v-if="imageUrl" :src="imageUrl" alt="Image" />
        <p v-else-if="errorMessage">{{ errorMessage }}</p>
        <p v-else>Loading image...</p>
    </div>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
export default {
    name: 'ImageViewer',
    props: ['imageId'],
    data() {
        return {
            imageUrl: null,
            errorMessage: null,
        };
    },
    mounted() {
        const imageId = this.$route.params.imageId;
        const imageName = this.$route.query.imageName;

        this.fetchImageData(imageId, imageName);
    },
    methods: {
        async fetchImageData(imageId, imageName) {
            try {
                const response = await HTTP.get(`/image/getImageData/${imageId}?imageName=${imageName}`);
                if (response.data && response.data.imageUrl) {
                    this.imageUrl = response.data.imageUrl;
                } else {
                    this.errorMessage = "Image not found.";
                }

            } catch (err) {
                console.error('Failed to load image:', err);
                this.errorMessage = "An error occurred while loading the image.";
            }
        },
    },
};
</script>

<style scoped>
.image-viewer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

img {
    max-width: 100%;
    max-height: 100%;
}
</style>
